import React, { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { HINWEIS_AN_HA_PLACEHOLDER_TEXT, PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import {
	AbschlussSeiteHinweisFeldBox,
	AbschlussSeiteHochladeFeldBox,
	FinaleSchritteInfoBosZwischenBericht,
} from '../../../antrag-components/AbschlussSeiteBox';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { FormStrucItem } from '../../../../../../lib/types/types';

import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
import { concat } from 'lodash';
const P = Schema.attributes;

const AbschlussZwischenBericht: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<ApplicationHeading title="Abschluss" description={PLATZHALTER_TEXT} />

			<FinaleSchritteInfoBosZwischenBericht />

			<AbschlussSeiteHochladeFeldBox>
				<CreateForm
					formStruc={formStrucUpload()}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={readOnly}
				/>
			</AbschlussSeiteHochladeFeldBox>

			<AbschlussSeiteHinweisFeldBox>
				<CreateForm
					formStruc={formStrucHinweis()}
					formValues={application}
					updateFormValuesFunc={setApplicationProperty}
					readOnly={readOnly}
				/>
			</AbschlussSeiteHinweisFeldBox>
		</>
	);
};
export default AbschlussZwischenBericht;

const formStrucUpload = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Allgemein_Eingereichter_Zwischenbericht, hideLabel: true }],
			userProps: { columnToDivide: 1 },
		},
	];

	return struc;
};

const formStrucHinweis = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Allgemein_Hinweise_An_Die_HA, placeholder: HINWEIS_AN_HA_PLACEHOLDER_TEXT }],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAbschlussZwischenBericht = () => {
	return concat(formStrucUpload());
};
